import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Cross from '../pics/svg/cross.svg';
import Error from '../popups/error';
import firebase from 'firebase/app';
import "./signup.css";

class Signup extends Component{

    constructor(props){
        super(props)
        this.state = {
            emailSignUp: '',
            passwordSignUp: '',
            emailEmpty: true,
            passwordEmpty: true
        }
        this.hideSignUpButton = this.hideSignUpButton.bind(this);
        this.showSignUpButton = this.showSignUpButton.bind(this);
        this.closeSignup = this.closeSignup.bind(this);
        this.auth = firebase.auth();
        this.emailProvider = new firebase.auth.EmailAuthProvider();
    }

    componentDidUpdate() {
        (!this.state.emailEmpty && !this.state.passwordEmpty) ? this.showSignUpButton() : this.hideSignUpButton()
    }
    hideSignUpButton() {
        document.querySelector('.Signup').style.opacity = 0;
        document.querySelector('.Signup').style.pointerEvents = 'none';
    }
    showSignUpButton() {
        document.querySelector('.Signup').style.opacity = 1;
        document.querySelector('.Signup').style.pointerEvents = 'all';
    }
    closeSignup() {
        document.querySelector('.signup-wrapper').style.transform = "scale(0.8)";
        document.querySelector('.signup-wrapper').style.opacity = 0;
        document.querySelector('.signup-wrapper').style.pointerEvents = "none";
        this.hideSignUpButton();
    }

    handleEmailChange = (event) => {
        event.target.value === '' ? this.setState({ emailEmpty: true }) : this.setState({ emailEmpty: false }) 
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handlePasswordChange = (event) => {
        event.target.value === '' ? this.setState({ passwordEmpty: true }) : this.setState({ passwordEmpty: false })
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    onSignUpClick = () => {
        let email = this.state.emailSignUp;
        let password = this.state.passwordSignUp;
        firebase.auth().createUserWithEmailAndPassword(email, password).catch(function (error) {
            ReactDOM.render(<Error oops={error} />, document.querySelector('.error-container'));
            document.querySelector('.error').classList.add('show')
        });
        this.closeSignup();
    }

    handleEnter = (event) => {
        if (event.keyCode === 13 && !this.state.emailEmpty && !this.state.passwordEmpty) {
            event.preventDefault();
            this.onSignUpClick();
        }
    }

    render() {
        return (
            <div className="signup-wrapper">
                <div className="signup-container">
                    <img onClick={this.closeSignup} className="close" src={Cross} alt="X"/>
                    <div className="signup-heading">Make an account</div>
                    <div className="email-container">
                        <input
                            autoComplete="on"
                            onChange={this.handleEmailChange}
                            onKeyUp={this.handleEnter}
                            className="emailSignUpInput"
                            name="emailSignUp"
                            type="email"
                            placeholder="Email" />
                        <input
                            autoComplete="on"
                            onChange={this.handlePasswordChange}
                            onKeyUp={this.handleEnter}
                            className="passwordSignUpInput"
                            name="passwordSignUp"
                            type="password"
                            placeholder="Password" />
                        <button onClick={this.onSignUpClick} className="Signup">Sign Up</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Signup;
